// extracted by mini-css-extract-plugin
export default {"form":"MessagesSurvey_form__2ALwO"};